import { Component } from '@angular/core';
import { NewModalRef } from 'outshared-lib';

@Component({
    selector: 'ins-appointment-confirmation-modal',
    templateUrl: 'appointment-confirmation.modal.html',
})
export class AppointmentConfirmationModal {
    model: any = {
        naam: '',
        datum: '',
        tijdstip: '',
    };

    constructor(
        private activeModal: NewModalRef<AppointmentConfirmationModal>,
    ) {}

    public close(): void {
        this.activeModal.close({
            confirm: true,
        });
    }

    public dismiss(): void {
        this.activeModal.close();
    }
}
